export const addressLink = (network, address) => {
  return `https://astar-zkevm.explorer.startale.com/address/${address}}`;
};

export const transactionLink = (network, hash) => {
  return `https://astar-zkevm.explorer.startale.com/tx/${hash}`;
}